module.exports = __webpack_public_path__ + "static/img/200217.9dd87df4.png";